/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Register {
    angular.module("meevo.plugins.register", []);
}